export const GET_DIRECTORY_LIST = "/api/v2/directory/list/withChannel";
export const GET_CHANNEL_WITH_DIRECTORY_LIST = "/api/v2/channel/management/list";
export const GET_ALL_APPLICATION = "/api/v2/application/all/list";
export const GET_APPLICATION_DETAILS = "/api/v2/application/details";
export const CREATE_DIRECTORY = "/api/v2/directory/create";
export const UPDATE_DIRECTORY = "/api/v2/directory/update";
export const GET_GROUP_LIST = "/api/v2/group/list";
export const GET_DIRECTORY_DETAILS = "/api/v2/directory/details";
export const UPLOAD_APPLICATION_LOGO = "/api/v2/upload/application";
export const CREATE_NEW_APPLICATION = "/api/v2/application/create";
export const UPDATE_APPLICATION = "/api/v2/application/update";
export const GET_CHANNEL_DETAILS = "/api/v2/channel/details";
export const GET_CHANNEL_SMTP_DETAILS = "/api/v2/channel/smtp/details";
export const GET_CHANNEL_STORAGE_DETAILS = "/api/v2/channel/storage/details";
export const SAVE_CHANNEL_STORAGE_DETAILS = "/api/v2/channel/save/storage/details";
export const SAVE_CHANNEL_SMTP_DETAILS = "/api/v2/channel/save/smtp/details";
export const CREATE_NEW_CHANNEL = "/api/v2/channel/create";
export const UPDATE_CONFIGURATION_VARIABLES = "/api/v2/application/configuration/update";
export const CREATE_DEFAULT_CONFIGURATION = "/api/v2/application/create/default/configuration";
export const SAVE_DEFAULT_CONFIGURATION = "/api/v2/application/update/default/configuration";
export const GET_APP_WITH_DEFAULT_CONFIG = "/api/v2/application/default/configuration";
export const FETCH_DIRECTORY_APPLICATIONS = "/api/v2/directory/applications";
export const FETCH_DIRECTORY_CHANNELS = "/api/v2/directory/channel/list";
export const FETCH_APPLICATION_ENDPOINTS = "/api/v2/application/endpoints/list";
export const UPDATE_APPLICATION_ENDPOINTS = "/api/v2/application/update/endpoints";
export const ASSIGN_APPLICATION_TO_CHANNEL = "/api/v2/channel/assign/application";
export const GET_CHANNEL_APPLICATIONS = "/api/v2/channel/applications/list";
export const GET_CHANNEL_LOGIN_METHODS = "/api/v2/channel/login/methods";
export const FETCH_ENUM_TYPES = "/api/v2/channel/types";
export const FETCH_APPLICATION_TEMPLATE = "/api/v2/application/default/template";
export const FETCH_CHANNEL_APPLICATIONS = "/api/v2/channel/applications/list";
export const ASSIGN_APPLICATION_TO_DIRECTORY = "/api/v2/directory/assign/applications";
export const CONNECT_APPLICATION_WITH_DIRECTORY = "/api/v2/directory/link/application";
export const FETCH_CHANNEL_APPLICATION_CONFIG = "/api/v2/channel/application/configuration";
export const CREATE_LOGIN_METHOD = "/api/v2/channel/create/login/method";
export const UPDATE_LOGIN_METHOD = "/api/v2/channel/update/login/method";
export const DELETE_LOGIN_METHOD = "/api/v2/channel/delete/login/method";
export const UPDATE_ENVIRONMENT_VARIABLES = "/api/v2/application/update/environmentvariables";
export const FETCH_ENVIRONMENTAL_VARIABLE_KEY_NAMES = "/api/v2/channel/endpoint/name/list";

export const GET_CHANNEL_LIST = "/api/v2/channel/all/list";
export const FETCH_DIRECTORY_LIST = "/api/v2/directory/list";
export const CATEGORY_TAGS_LIST = "/api/v2/category/tags/list";
export const CREATE_CHANNEL_GROUP = "/api/v2/channel/create/group";
export const FETCH_LOGIN_METHODS_DATA = "/api/v2/channel/loginmethods/list";

export const FETCH_DIRECTORY_APPLICATION_ENDPOINTS = "/api/v2/channel/directory/endpoints";
export const FETCH_DIRECTORY_APPLICATION_ENVIRONMENT_VARIABLE = "/api/v2/channel/directory/env";
export const UPLOAD_CHANNEL_CONFIGURATION_LOGO = "/api/v2/upload/configuration";
export const UPDATE_CHANNEL_CONFIGURATION = "/api/v2/channel/update/channel/configuration";
export const FETCH_BUNDLE_LIST = "/api/v2/group/bundle/list";
